import { createStore } from 'zustand-x';

interface AlertFilters {
  search: string;
  moduleType: string;
  severity: string;
  sortBy: string;
  groupBy: string;
}

const defaultFilters: AlertFilters = {
  search: '',
  moduleType: 'all',
  severity: 'all',
  sortBy: 'newest',
  groupBy: 'moduleType',
};

export const useFiltersStore = createStore('alertsfilter')({
  filters: defaultFilters,
}).extendActions((set) => ({
  updateFilter: (key: any, value: AlertFilters) => {
    // if (!value) {
    //   throw new Error('No Filter Value');
    // }
    set.state((state) => ({
      ...state,
      filters: { ...state.filters, [key]: value },
    }));
  },
  removeFilters: () => {
    set.state(() => ({
      filters: defaultFilters,
    }));
  },
}));
